import { IconSVG } from '../types';

export const Bug = ({ size, style }: IconSVG) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 -960 960 960"
      style={style}
    >
      <path
        d="M480-111.87q-67.63 0-125.4-33.79-57.77-33.8-90.73-92.43h-112v-83.82h83.76q-2.76-19.05-3.26-37.97t-.5-38.21h-80v-83.82h80q0-19.29.5-38.21t3.26-37.97h-83.76v-83.82h113.2q13.04-23.96 30.9-44.32t41.1-35.84l-64.48-66 59.11-58.86 86 86q29.43-10.44 60.22-10.68 30.8-.24 60.23 9.96l88.48-86.72 58.87 58.87-65.52 65.52q24.43 15.96 43.53 37.01 19.1 21.06 32.86 46.97h111.76v81.91h-83.76q2.76 19.05 3.26 37.97t.5 38.21h80v83.82h-80q0 19.29-.62 38.21t-3.38 37.97h84v83.82h-112q-32.96 58.63-90.73 92.43-57.77 33.79-125.4 33.79m-80-206.22h160v-83.82H400zm0-160h160v-83.82H400z"
        fill="currentColor"
      />
    </svg>
  );
};
